import { z } from "zod";

export const MaquinasequipSchema = z.object({
  idMaquinasequip: z.number().nullable().default(null),
  ativo: z.number().default(1),
  dataCadastro: z.coerce.date().nullable().default(null),
  codigo: z.string().nullable().default(null),
  idCentroCusto: z.number().nullable().default(null),
  descricao: z.string().nullable().default(null),
  criterioAceitacao: z.string().nullable().default(null),
  referenciaAceitacao: z.string().nullable().default(null),
  quantidade: z.coerce.number().nullable().default(null),
  dataAquisicao: z.coerce.date().nullable().default(null),
  dataGarantia: z.coerce.date().nullable().default(null),
  descResponsavelMonit: z.string().nullable().default(null),
  idFuncionarioMonit: z.number().nullable().default(null),
  idFornecedorMonit: z.number().nullable().default(null),
  descResponsavelResp: z.string().nullable().default(null),
  idFuncionarioResp: z.number().nullable().default(null),
  tipoMonitoramento: z.coerce.number().default(0),
  frequenciaVerificacao: z.coerce.number().nullable().default(null),
  dataProxVerificacao: z.coerce.date().nullable().default(null),
  dataVerificacao: z.coerce.date().nullable().default(null),
  marca: z.string().nullable().default(null),
  modelo: z.string().nullable().default(null),
  valor: z.coerce.number().nullable().default(null),
  tipo: z.string().nullable().default(null),
  idFornecedor: z.number().nullable().default(null),
  status: z.number().nullable().default(null),
  fatorGerador: z.number().nullable().default(null),
  faixaDeUso: z.string().nullable().default(null),
  localizacao: z.string().nullable().default(null),
  observacao: z.string().nullable().default(null),
  tipoCalibradoMonit: z.coerce.number().default(0),
  preencherRespCal: z.coerce.boolean().default(false),
  preencherRespResp: z.coerce.boolean().default(false),
});



export type MaquinasequipForm = z.infer<typeof MaquinasequipSchema>;

export const initialMaquinasEquipForm: Partial<MaquinasequipForm> = {
  ativo: 1,
  tipoMonitoramento: 2,
  fatorGerador: 0,
  status: 0,
  tipoCalibradoMonit: 2,
  preencherRespCal: false,
  preencherRespResp: false,
  dataCadastro: new Date(),
};